import { render, staticRenderFns } from "./checkout.vue?vue&type=template&id=0423a873"
import script from "./checkout.vue?vue&type=script&lang=ts"
export * from "./checkout.vue?vue&type=script&lang=ts"
import style0 from "./checkout.vue?vue&type=style&index=0&id=0423a873&prod&lang=sass"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports